/**
 * Мелкие настройки приложения. В телефонной оболочке — Capacitor Preferences
 * (переживают очистку кэша WebView), в браузере тот же плагин пишет в
 * localStorage. Любая ошибка хранилища глотается: настройка не стоит сбоя.
 */
import { Preferences } from '@capacitor/preferences';

export async function readPref(key: string): Promise<string | null> {
  try {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  } catch {
    try { return localStorage.getItem(key); } catch { return null; }
  }
}

export async function writePref(key: string, value: string | null): Promise<void> {
  try {
    if (value === null) await Preferences.remove({ key });
    else await Preferences.set({ key, value });
  } catch {
    try {
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch { /* хранилище закрыто */ }
  }
}
